import script from "./DEP.vue?vue&type=script&setup=true&lang=js"
export * from "./DEP.vue?vue&type=script&setup=true&lang=js"

import "./DEP.vue?vue&type=style&index=0&id=42fdf128&lang=css"

const __exports__ = script;

export default __exports__